import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "edit-supplier-modal";

const keys = addTranslations(RESOURCE_NAME, {
    modal_title: {
        en: "Edit Supplier",
        fr: "Modifier le fournisseur",
    },
    supplier_name_placeholder: {
        en: "Supplier name",
        fr: "Nom du fournisseur",
    },
    supplier_name_error: {
        en: "Supplier name is required",
        fr: "Le nom du fournisseur est requis",
    },
    cancel_btn: {
        en: "Cancel",
        fr: "Annuler",
    },
    save_btn: {
        en: "Save",
        fr: "Enregistrer",
    },
});

export function useEditSupplierModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
